import { IAccordionItem } from "../../components/AccordionList";
import { TeacherDetailTypeEnum } from "./types";

export const TEACHING_LEVEL = [
  {
    id: 1,
    name: "Elementary School",
  },
  {
    id: 2,
    name: "Middle School",
  },
  {
    id: 3,
    name: "High School",
  },
  {
    id: 4,
    name: "Bachelor",
  },
  {
    id: 5,
    name: "Master",
  },
];

export const teacherDetailsConfig: IAccordionItem[] = [
  {
    type: TeacherDetailTypeEnum.Bio,
    name: "Bio",
    isRequired: true,
  },
  {
    type: TeacherDetailTypeEnum.Education,
    name: "Education",
    isRequired: true,
  },
  {
    type: TeacherDetailTypeEnum.Experience,
    name: "Experience",
    isRequired: true,
  },
  {
    type: TeacherDetailTypeEnum.Calendar,
    name: "Calendar",
    isRequired: false,
  },
];
